import { render, staticRenderFns } from "./DiscountPopinIntroShared.vue?vue&type=template&id=8bffe108"
import script from "./DiscountPopinIntroShared.vue?vue&type=script&lang=ts"
export * from "./DiscountPopinIntroShared.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports